import { ZStack as NbZStack } from 'native-base';

import { addWithConfig } from '../../utils';

export const ZStack = NbZStack;

export default addWithConfig(ZStack);
